import { Eye, MaskSad } from "phosphor-react";
import React from "react";
import useNavigation from "~/admin/hooks/useNavigation";
import Badge from "~/admin/components/Badge";
import Card from "~/admin/components/Card";
import Table from "~/admin/components/Table";
import Td from "~/admin/components/Td";
import Th from "~/admin/components/Th";
import Tr from "~/admin/components/Tr";
import Pagination from "~/admin/components/Pagination";
import SearchInput from "~/admin/components/SearchInput";

export default function CompaniesTab({ companies, onSearch, onPaginate }) {
  const { navigate } = useNavigation();

  return (
    <>
      {companies.items?.length > 0 ? (
        <Card>
          <div className="md:max-w-[300px] mb-2">
            <SearchInput
              onSearch={onSearch}
              placeholder="Rechercher une entreprise"
            />
          </div>
          <Table>
            <thead>
              <Tr>
                <Th>Nom</Th>
                <Th>Email</Th>
                <Th>Visibilité</Th>
                <Th></Th>
              </Tr>
            </thead>
            <tbody>
              {companies.items.map((company) => {
                return (
                  <Tr key={company.id}>
                    <Td>{company.name}</Td>
                    <Td>{company.email}</Td>
                    <Td>
                      {company.user.visible ? (
                        <Badge color="success">Visible</Badge>
                      ) : (
                        <Badge color="danger">Incognito</Badge>
                      )}
                    </Td>
                    <Td>
                      <Eye
                        className="cursor-pointer hover:text-gray-400"
                        onClick={() => navigate(`companies/${company.id}`)}
                        size={24}
                      />
                    </Td>
                  </Tr>
                );
              })}
            </tbody>
          </Table>
          <div className="pt-4 text-center">
            <Pagination
              lastPage={companies.lastPage}
              currentPage={companies.currentPage}
              onPaginate={onPaginate}
            />
          </div>
        </Card>
      ) : (
        <div className="px-4 py-2 bg-blue-300 text-blue-700 w-fit rounded-md mx-auto flex space-x-4 items-center">
          <div>
            <MaskSad />
          </div>
          <div>Il n'y a aucune entreprise pour l'instant !</div>
        </div>
      )}
    </>
  );
}
